const TONES = { CONFIRMED: "#2E7D46", AMENDED: "#C97A1A", CANCELLED: "#B23B3B", PENDING: "#3157A4", COMPLETED: "#16213E" };

// CSS conic donut bound to the real booking_status_breakdown - no chart library, no fabricated segments.
export function StatusDonut({ segments, total }) {
  if (!total) return <p className="text-sm text-jigsaw-muted">No bookings recorded yet.</p>;
  let acc = 0;
  const stops = segments.map((s) => {
    const from = (acc / total) * 100; acc += s.count; const to = (acc / total) * 100;
    return `${TONES[s.status] || "#98A2B3"} ${from}% ${to}%`;
  }).join(", ");
  return (
    <div className="flex items-center gap-5">
      <div data-testid="status-donut" className="relative h-[120px] w-[120px] shrink-0 rounded-full" style={{ background: `conic-gradient(${stops})` }}>
        <div className="absolute inset-[16px] flex flex-col items-center justify-center rounded-full bg-white">
          <span className="text-[22px] font-bold leading-none text-jigsaw-navy">{total}</span>
          <span className="text-[10px] uppercase tracking-wide text-jigsaw-muted">bookings</span>
        </div>
      </div>
      <ul className="space-y-1.5 text-sm">
        {segments.map((s) => (
          <li key={s.status} className="flex items-center gap-2">
            <span className="h-2.5 w-2.5 rounded-full" style={{ background: TONES[s.status] || "#98A2B3" }} />
            <span className="text-jigsaw-navy">{s.status.charAt(0) + s.status.slice(1).toLowerCase()}</span>
            <span className="ml-auto pl-3 font-mono-ref text-jigsaw-muted">{s.count}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
